/*eslint no-unused-vars: "error"*/
import React, { useEffect, useState } from 'react';
import { fetchAdminApi, fetchApi } from "../../../services/api";
import constants from '../../../constants/constants';
import { Button, message, Spin, Space } from 'antd';
import { useHistory } from "react-router";
import { DOB } from "../../../../src/globalFunctions/GlobalFunctions";
import { COOKIE, getCookie } from "../../../services/cookie";
import logo_bw from '../../../assets/logo-blue.svg';
import NotesModal from '../../component/NotesModal';
import moment from 'moment';

const ViewClientProfile = (props) => {
	const history = useHistory();
	const [loader, setLoader] = useState(false);

	//notes
	const current = new Date();
	const [noteDate, setNoteDate] = useState({
		date: current.getDate(),
		month: String(current.getMonth() + 1).padStart(2, '0'),
		year: current.getFullYear()
	});
	const [notesVisible, setnotesVisible] = useState(false);
	const [noteValue, setNoteValue] = useState(null);
	const [noteTypeValue, setNoteTypeValue] = useState("0");
	const [sessionChecked, setSessionChecked] = useState(false);
	const [isNoteAnswered, setIsNoteAnswered] = useState(false);
	const [assessmentBehavior, setAssessmentBehavior] = useState([]);
	const [notefollowUp, setNoteFollowUp] = useState(false);

	const [enquiryDetails, setEnquiryDetails] = useState({});
	let enquiryDetailsfromSession = JSON.parse(sessionStorage.getItem("enquiryDetails"));
	const [clientDetails, setClientDetails] = useState([]);
	const loggedInClientId = getCookie(COOKIE.ClientId);

	useEffect(() => {
		sessionStorage.removeItem('adminClientValueFam');
		let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
		if (props && props.location && props.location.state && props.location.state.client_id || adminClientValue?.clientId) {
			fetchClientDetails(props && props.location && props.location.state && props.location.state.client_id || adminClientValue?.clientId);
		} else {
			fetchEnquiryDetails(props && props.location && props.location.state && props.location.state.enquiry_id || enquiryDetailsfromSession?.enquiry_id);
		}
		return () => {
			// Remove the session here
			sessionStorage.removeItem('adminClientValue');
			sessionStorage.removeItem('enquiryDetails');
		};
	}, []);

	const hideModal = () => {
		setNoteTypeValue("0");
		setnotesVisible(false);
		setNoteFollowUp(false);
		setSessionChecked(false);
	};

	const onchangeNoteValue = (e, index) => {
		setNoteValue(prev => {
			const updated = [...prev];
			updated[index] = e;
			return updated;
		});
	};
	const onSessionChange = (value) => {
		setSessionChecked(value);
	}

	const addNotes = (clientType) => {
		if ((clientType === "client" && clientDetails.is_note_answered === 0) || enquiryDetails.is_note_answered === 0) {
			let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
			let payload;
			if (clientType === "client") {
				payload = {
					clientId: props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id,
					client_serial_number: clientDetails?.client_serial_number,
					client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname
				};
			} else {
				payload = {
					enquiryId: props && props.location && props.location.state && props.location.state.enquiry_id || enquiryDetails?.enquiry_id,
					client_serial_number: enquiryDetails?.enquiry_id,
					client_name: enquiryDetails?.client_firstname + " " + enquiryDetails?.client_lastname
				};
			}
			if (adminClientValue === null) {
				sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
			}
			window.open(constants.BaseUrl + "/add-note");
		} else {
			document.getElementById('top').scrollIntoView({ behavior: "smooth" });
			getForm(noteTypeValue);
			setnotesVisible(true);
		}
	};

	const createNote = (type) => {
		let payload;
		const enquiryId = props?.location?.state?.enquiry_id || enquiryDetailsfromSession?.enquiry_id;
		let assessmentText = '';
		if (noteValue[1]) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> " + noteValue[1];
		} else if (assessmentBehavior?.length > 0) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> ";
		}

		payload = {
			notes_content: noteValue[0] ? "<b><u>DATA:</u></b>" + " " + noteValue[0] : "",
			notes_assesment: assessmentText,
			notes_plan: noteValue[2] ? "<b><u>PLAN:</u></b>" + " " + noteValue[2] : "",
			section_id: null,
			admin_id: loggedInClientId,
			notes_type: noteTypeValue,
			dt_created: `${noteDate.year}-${noteDate.month}-${noteDate?.date}`
		};

		if (enquiryId) {
			payload.enquiry_id = enquiryId;
		} else {
			payload.client_id = clientDetails?.client_id;
		}
		if (noteTypeValue === "0") {
			const clientName =
				((props?.location?.state?.enquiry_id || enquiryDetailsfromSession?.enquiry_id)
					? enquiryDetails?.client_firstname
					: clientDetails?.client_firstname) || "Client";

			const behaviorSentence = assessmentBehavior?.length > 0
				? `<h3>${clientName} ${assessmentBehavior?.join(', ')}.</h3>`
				: '';

			payload.notes_assesment_behaviour = behaviorSentence;
			payload.answers = {
				...(payload.answers || {}),
				follow_up: notefollowUp ? 1 : 0,
				assessment_behavior: assessmentBehavior
			};
		}
		if (sessionChecked === true) {
			payload.session_checked = sessionChecked;
		}
		if (type === "esign") {
			payload.signed_by = loggedInClientId;
		}
		if (noteValue !== null) {
			fetchAdminApi(`/add-notes`, "post", payload).then((res) => {
				if (res && res.code && res.code === 200) {
					setNoteDate({
						...noteDate,
						date: current.getDate(),
						month: String(current.getMonth() + 1).padStart(2, '0'),
						year: current.getFullYear()
					});
					setAssessmentBehavior([]);
					message.success(res.message);
				} else {
					message.error(res.message);
				}
			});
		}
		hideModal();
	};

	//date of notes date onchange
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date: value
		});
	};
	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month: value
		});
	};
	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year: value
		});
	};
	const onFollowUpChange = (checked) => {
		setNoteFollowUp(checked);
		const isEnquiryUser = (props?.location?.state?.enquiry_id || enquiryDetailsfromSession?.enquiry_id);

		const firstName = isEnquiryUser
			? enquiryDetails?.client_firstname
			: clientDetails?.client_firstname;

		if (checked) {
			onchangeNoteValue(constants.FollowUpData1 + `${firstName || "Client"}` + constants.FollowUpData2, 0);
			onchangeNoteValue(constants.FollowUpAssessment, 1);
			onchangeNoteValue(constants.FollowUpPlan, 2);
		} else {
			onchangeNoteValue("", 0);
			onchangeNoteValue("", 1);
			onchangeNoteValue("", 2);
		}
	};

	const fetchEnquiryDetails = (enquiry_id) => {
		let payload = {
			enquiry_id: enquiry_id,
		}
		fetchApi(`/get-enquiry`, "post", payload).then((res) => {
			if (res && res.data) {
				setEnquiryDetails(res.data);
				let sessionPayload = res?.data;
				if (props?.location?.state) {
					sessionPayload.show_other_details = props?.location?.state?.show_other_details
				};
				sessionStorage.setItem("enquiryDetails", JSON.stringify(sessionPayload));
			} else {
				message.error(res.message);
				setEnquiryDetails({});
			}
		});
	};

	//fetching client data
	const fetchClientDetails = (client_id) => {
		setLoader(true);
		fetchAdminApi(`/client-profile/${client_id}`, "get",).then((res) => {
			if (res && res.data) {
				setLoader(false);
				setClientDetails(res.data);
			}
			else {
				setClientDetails([]);
				setLoader(false);
			}
		});
	};

	const redirectToClientDashboard = () => {
		let payload = {
			isAdmin: true,
			clientId: clientDetails?.client_id,
			client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname,
			client_serial_number: clientDetails?.client_serial_number
		};
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/dashboard");
	};

	const redirectToRecovryAndDischargePlan = (type) => {
		let url = type === 1 ? "/recovery-plan" : "/discharge-plan"
		let payload = {
			client_name: (clientDetails?.client_firstname && clientDetails?.client_lastname)
				? clientDetails.client_firstname + " " + clientDetails.client_lastname
				: enquiryDetails?.client_firstname + " " + enquiryDetails?.client_lastname,
			client_serial_number: clientDetails?.client_serial_number || enquiryDetails?.client_serial_number,
			recoveryplan: clientDetails?.recovery_plan_answers || enquiryDetails?.recovery_plan_answers
		};

		if (clientDetails?.client_id) {
			payload.clientId = clientDetails?.client_id
		} else {
			if (enquiryDetails?.client_id) {
				payload.clientId = enquiryDetails?.client_id
			} else {
				payload.enquiryId = enquiryDetails?.enquiry_id
			}
		}
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + url);
	};

	const routeToListNotes = (clientType) => {
		let payload;
		if (clientType === "client") {
			payload = {
				clientId: props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id,
				client_serial_number: clientDetails?.client_serial_number,
				client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname,
				enquiryId: props && props.location && props.location.state && props.location.state.enquiry_id || clientDetails?.enquiry_info?.enquiry_id,
			};
		} else {
			payload = {
				enquiryId: props && props.location && props.location.state && props.location.state.enquiry_id || enquiryDetails?.enquiry_id,
				client_serial_number: enquiryDetails?.enquiry_id,
				client_name: enquiryDetails?.client_firstname + " " + enquiryDetails?.client_lastname,
				enquiry_info: enquiryDetails
			};
			if (enquiryDetails?.client_id) {
				payload.clientId = enquiryDetails?.client_id
			}
		}
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/notes");
	};

	const redirectToFilesListing = () => {
		if (props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id) {
			let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
			let payload = {
				clientId: props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id,
				client_serial_number: clientDetails?.client_serial_number,
				client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname
			};
			if (adminClientValue === null) {
				sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
			}
			window.open(constants.BaseUrl + "/documents");
		} else {
			sessionStorage.removeItem("adminClientValue");
			window.open(constants.BaseUrl + "/documents");
		}
	};

	const redirectToPreAssessmentForm = () => {
		let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
		let payload;
		payload = {
			enquiryId: props && props.location && props.location.state && props.location.state.enquiry_id || enquiryDetails?.enquiry_id,
			client_serial_number: enquiryDetails?.enquiry_id,
			client_name: enquiryDetails?.client_firstname + " " + enquiryDetails?.client_lastname
		}
		if (adminClientValue === null) {
			sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		}
		sessionStorage.setItem("enquiryDetails", JSON.stringify(enquiryDetails));
		window.open(constants.BaseUrl + "/pre-assessment-intake");
	};

	const redirectToScreening = () => {
		if (props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id) {
			let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
			let payload = {
				clientId: props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id,
				client_serial_number: clientDetails?.client_serial_number,
				client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname
			};
			if (adminClientValue === null) {
				sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
			}

			clientDetails?.reset_date ? sessionStorage.setItem("clientDetailsForReset", JSON.stringify(clientDetails)) : null;

			sessionStorage.removeItem("assessmentQuestions");
			window.open(constants.BaseUrl + "/screening-form");
		} else {
			sessionStorage.removeItem("assessmentQuestions");
			sessionStorage.removeItem("adminClientValue");
			sessionStorage.removeItem("clientDetailsForReset");
			window.open(constants.BaseUrl + "/screening-form");
		}
	};

	const redirectToAdmissionForm = () => {
		if (props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id) {
			let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
			let payload = {
				clientId: props && props.location && props.location.state && props.location.state.client_id || clientDetails?.client_id,
				client_serial_number: clientDetails?.client_serial_number,
				client_name: clientDetails?.client_firstname + " " + clientDetails?.client_lastname,
				enquiry_info: clientDetails?.enquiry_info
			};
			if (adminClientValue === null) {
				sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
			}
			window.open(constants.BaseUrl + "/admission-assessment-form");
		} else {
			sessionStorage.removeItem("adminClientValue");
			window.open(constants.BaseUrl + "/admission-assessment-form");
		}
	};

	const routeToEditClient = (client_id, enable = null) => {
		let payload = {};
		if (enable) {
			payload.client_id = client_id;
			payload.enable = true;
		} else {
			payload.client_id = client_id;
		}
		history.push({
			pathname: "/edit-client",
			state: payload
		});
	};

	const routeToEditClientEnquiry = (enquiry_id, record) => {
		let pathname;
		let state;
		if (record?.status === "4" || record?.status === "9") {
			sessionStorage.removeItem("enquiryDetails");
			pathname = "/edit-client";
			state = { client_id: record?.client_id };
		} else {
			sessionStorage.setItem("enquiryDetails", JSON.stringify(record));
			pathname = "/edit-enquiry";
			state = {
				enquiry_id: enquiry_id,
				show_other_details: record?.show_other_details
			};
		}
		history.push({
			pathname: pathname,
			state: state
		});
	};

	const formatDate = (date) => {
		if (!date) return '-';
		return moment(date).isValid()
			? moment(date).format(constants.dateformat)
			: '-';
	};

	const headerForm = (type) => {
		let clientType;
		let label;
		let firstName;
		let lastName;
		let serialNo;
		let commonID;
		if (props && props.location && props.location.state && props.location.state.enquiry_id || enquiryDetailsfromSession?.enquiry_id) {
			label = constants.Enquiry + " " + constants.Details;
			firstName = enquiryDetails?.client_firstname;
			lastName = enquiryDetails?.client_lastname;
			serialNo = enquiryDetails?.enquiry_id;
			commonID = enquiryDetails?.enquiry_id;
			clientType = "enquiryUser";
		} else {
			label = constants.clientDetailFormheader;
			firstName = clientDetails?.client_firstname;
			lastName = clientDetails?.client_lastname;
			serialNo = clientDetails?.client_serial_number;
			commonID = clientDetails?.client_id;
			clientType = "client";
		}
		if (type === "page") {
			return label;
		} else if (type === "title") {
			return <>{label} - {firstName} {lastName} (#{serialNo})</>;
		} else if (type === "label") {
			return <div className="p-4 bg-white rounded space-y-2 w-fit text-base">
				<div>
					<span className="font-semibold ">{clientType === "enquiryUser" ? constants.Enquiry + " " + constants.Name : constants.clientName}:</span> {firstName} {lastName}
				</div>
				<div>
					<span className="font-semibold ">{clientType === "enquiryUser" ? constants.Enquiry + " ID" : constants.Client + " ID"}:</span> {commonID}
				</div>
				<div>
					<span className="font-semibold">{constants.phone}:</span> {clientType === "enquiryUser" ? enquiryDetails?.client_contact_number : clientDetails?.client_contact_number}
				</div>
				<div>
					<span className="font-semibold">{constants.Doe}:</span> {formatDate(clientType === "enquiryUser" ? enquiryDetails?.dt_created : clientDetails?.enquiry_info?.dt_created)}
				</div>
				<div>
					<span className="font-semibold ">Date of Admission:</span> {formatDate(clientType === "enquiryUser" ? enquiryDetails?.date_of_admission : clientDetails?.date_of_admission)}
				</div>
				<div>
					<span className="font-semibold">Date of Completion:</span> {formatDate(clientType === "enquiryUser" ? enquiryDetails?.dt_ended : clientDetails?.dt_ended)}
				</div>
			</div>
		} else {
			return <div className="relative z-20 justify-self-center !text-sm px-7 pb-3">
				<div className='mt-2'>
					<div className="flex flex-col items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[160px] font-semibold text-gray-800">
							{constants.NonBillable} :
						</div>
						<div className="flex flex-wrap gap-2">
							{clientDetails?.total_sessions?.non_billable?.length > 0 ? (
								clientDetails?.total_sessions?.non_billable?.map((val, index) => (
									<div
										key={index}
										className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
									>
										<span className="font-semibold text-gray-800">{val.name}</span>
										<span className="text-gray-500">:</span>
										<span className="text-gray-800 font-medium">{val.notes}</span>
									</div>
								))
							) : (
								null
							)}
						</div>
					</div>
				</div>
				<div className='mt-2'>
					<div className="flex flex-col items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[160px] font-semibold text-gray-800">
							{constants.Billable} :
						</div>
						<div className="flex flex-wrap gap-2">
							{clientDetails?.total_sessions?.billable?.length > 0 ? (
								clientDetails?.total_sessions?.billable?.map((val, index) => (
									<div
										key={index}
										className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
									>
										<span className="font-semibold text-gray-800">{val.name}</span>
										<span className="text-gray-500">:</span>
										<span className="text-gray-800 font-medium">{val.notes}</span>
									</div>
								))
							) : (
								null
							)}
						</div>
					</div>
				</div>
			</div>
		}
	};

	const getForm = (formType) => {
		setNoteTypeValue(formType);
		let payload = { note_type: formType };
		if (enquiryDetailsfromSession?.enquiry_id) {
			payload.enquiry_id = enquiryDetailsfromSession?.enquiry_id;
		} else {
			payload.client_id = clientDetails?.client_id;
		}
		fetchAdminApi("/notes", 'post', payload).then((res) => {
			if (res?.code === 200) {
				setNoteValue(res?.data?.data);
				if (res?.data?.is_note_answered === 1) {
					setIsNoteAnswered(true);
				} else {
					setIsNoteAnswered(false);
				}
			} else {
				setNoteValue([]);
			}
		});
	};

	const getButtonLinks = () => {
		const isEnquiry =
			(props?.location?.state?.enquiry_id || enquiryDetailsfromSession?.enquiry_id);
		const clientType = isEnquiry ? "enquiryUser" : "client";

		const buttons = [
			{
				title: 'Profile',
				visible: true,
				onClick: () => {
					if (isEnquiry) {
						routeToEditClientEnquiry(isEnquiry, enquiryDetailsfromSession);
					} else {
						routeToEditClient(props.location?.state?.client_id || clientDetails?.client_id);
					}
				}
			},
			{
				title: constants.PreAssessment,
				visible: isEnquiry && ["0", "3", "10", "12"].includes(enquiryDetails?.status) && enquiryDetails?.show_preassesment === 1,
				onClick: () => redirectToPreAssessmentForm(),
			},
			{
				title: constants.ScreeningForm,
				visible: isEnquiry ? true && enquiryDetails?.client_id : true,
				onClick: () => redirectToScreening(),
			},
			{
				title: constants.AdmissionForm,
				visible: enquiryDetails?.screening_form_esign || clientDetails?.screening_form_esign,
				onClick: () => redirectToAdmissionForm(),
			},
			{
				title: constants.IndividualRecoveryPlan,
				visible: true,
				onClick: () => redirectToRecovryAndDischargePlan(1),
			},
			{
				title: !isEnquiry && clientDetails?.is_active === "1" ? constants.AdminWorkbook : constants.RefresherWorkSheet,
				visible: !isEnquiry && clientDetails?.is_active === "1",
				onClick: () => redirectToClientDashboard(),
			},
			{
				title: constants.ViewNotes,
				visible: true,
				onClick: () => routeToListNotes(clientType),
			},
			{
				title: constants.AddNote,
				visible: true,
				onClick: () => addNotes(clientType),
			},
			{
				title: constants.DocumentList,
				visible: true,
				onClick: () => redirectToFilesListing(),
			},
			{
				title: constants.DischargePlan,
				visible: clientDetails?.show_discharge_button,
				onClick: () => redirectToRecovryAndDischargePlan(2),
			},
			// {
			// 	title: constants.ConsentForm,
			// 	visible: true,
			// 	onClick: () => redirectToFriendsFamilyListing(clientType),
			// },
		];

		return buttons.filter(btn => btn.visible);
	};

	const handleAssessmentBehaviorChange = (value) => {
		setAssessmentBehavior(value);
	}

	const handleRedirect = () => {
		const hasEnquiryId =
			(props?.location?.state?.enquiry_id) ||
			enquiryDetailsfromSession?.enquiry_id;

		if (hasEnquiryId) {
			history.push("/client-enquiry-open-list");
		} else {
			history.push("/client-list-open");
		}
	};

	return (
		<Spin spinning={loader} size="large">
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">{headerForm("page")}</span>
			</div>
			<div className='bg-amber-100 text-base font-semibold p-2 mb-3'><div className="container mx-auto">
				<Space size={'small'} wrap direction="vertical">
					<span>{headerForm("title")}</span>
					<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={handleRedirect}>{constants.BackBtn}</Button>
				</Space>
			</div></div>
			<div className='container mx-auto px-2 pb-20 overflow-hidden md:overflow-visible'>

				{/* Buttons */}
				<div className="md:hidden md:invisible visible flex flex-wrap gap-2 mb-3">
					{getButtonLinks().map((btn, index) => (
						<Button
							key={index}
							onClick={btn.onClick}
							size="small"
							className="text-xs font-semibold bg-sky-800 text-white uppercase"
						>
							{btn.title}
						</Button>
					))}
				</div>

				{/* Book */}
				<div className="relative lg:max-w-xl max-w-md w-full min-h-[570px] h-full bg-amber-200 justify-self-center rounded-tr-lg rounded-br-lg shadow-lg flex flex-col justify-between">

					{/* Spine */}
					<div className="absolute top-0 left-1 w-0.5 h-full bg-amber-400 rounded-tl-md rounded-bl-md shadow-inner z-30" />
					<div className="absolute top-0 left-2.5 w-0.5 h-full bg-amber-400 rounded-tl-md rounded-bl-md shadow-inner z-30" />

					{/* Pages */}
					<div className="absolute bottom-0 left-[12%]  w-[200px] h-[350px] bg-white rotate-[-17deg] z-80 shadow-lg" />
					<div className="absolute bottom-1 right-0  w-[390px] h-[420px] bg-gray-200 rotate-[-30deg] z-80 shadow-lg" />
					<div className="absolute bottom-1 right-0  w-[390px] h-[420px] bg-white rotate-[-25deg] z-70 shadow-lg" />

					{/* Folder Body */}
					<div className="absolute top-0 left-0 w-full h-full bg-amber-200 rounded-tr-lg rounded-br-lg z-10" />

					{/* Header */}
					<img src={logo_bw} alt="Logo" preview={false} className='!w-24 relative pt-4 z-20 self-center' />

					{/* Client Label (looks like a sticker on the folder) */}
					<div className="relative pt-10 px-7 pb-5 z-20 self-center sm:self-start">
						<div className="p-0.5 bg-amber-400 rounded w-fit">
							<div className="p-1 bg-amber-200 rounded w-fit">
								<div className="p-0.5 bg-amber-400 rounded w-fit">
									{headerForm("label")}
								</div>
							</div>
						</div>
					</div>

					{/* Billable Notes details */}
					{headerForm("notes")}

					{/* Footer */}
					<div className='relative z-20 justify-self-center text-center w-full rounded-br-lg'>
						<div className='bg-amber-100 text-center text-xs font-light py-2'>
							<div>{constants.AnyoneRecover}</div>
							<div><i><span>Renew</span> • <span>Restart</span> • <span>Reset</span> • <span>Refocus</span></i></div>
						</div>
					</div>

					{/* Bookmarks */}
					<div className="hidden invisible md:visible md:absolute top-32 -right-[7.5rem] lg:-right-48 md:flex flex-col space-y-4 z-20 ">
						{getButtonLinks().map((btn, index) => (
							<Button
								key={index}
								onClick={btn.onClick}
								className="text-xs font-semibold bg-sky-800 text-white uppercase rounded-l-none rounded-r-md lg:px-14"
							>
								{btn.title}
							</Button>
						))}
					</div>

					{/* Ribbon */}
					<div className="absolute -bottom-[68px] left-6 w-6 h-20 bg-[#0191a7] flex items-center justify-center z-90">
						<span className="text-white font-bold text-xs transform -rotate-90 whitespace-nowrap">
							R.A.R.E.
						</span>
						<div className="absolute bottom-[-1px] left-0 w-0 h-0 -rotate-180 border-l-[12px] border-r-[12px] border-t-[12px] border-l-transparent border-r-transparent border-t-[#e7faff]" />
					</div>

				</div>
				{/* {noteValue && notesModel(hideModal, notesVisible, onchangeNoteValue, createNote, getForm, noteValue, noteTypeValue, isNoteAnswered, DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", false), onSessionChange, sessionChecked, false, null, null, assessmentBehavior, handleAssessmentBehaviorChange)} */}
				{noteValue && (
					<NotesModal
						hideModal={hideModal}
						notesVisible={notesVisible}
						onchangeNoteValue={onchangeNoteValue}
						createNote={createNote}
						getForm={getForm}
						noteValue={noteValue}
						noteTypeValue={noteTypeValue}
						disable={isNoteAnswered}
						date={DOB(
							noteDate.month,
							handleNoteMonthChange,
							noteDate.date,
							handleNoteDayChange,
							noteDate.year,
							handleNoteYearChange,
							"Date",
							false
						)}
						onSessionChange={onSessionChange}
						sessionChecked={sessionChecked}
						isSessionPresent={false}
						nextPreviousButton={null}
						isEdit={null}
						assessmentBehavior={assessmentBehavior}
						handleAssessmentBehaviorChange={handleAssessmentBehaviorChange}
						notefollowUp={notefollowUp}
						onFollowUpChange={onFollowUpChange}
					/>
				)}
			</div>
		</Spin>
	);
};

export default ViewClientProfile;